import { render } from "./BookmarksModal.vue?vue&type=template&id=19cff8ba&scoped=true"
import script from "./BookmarksModal.vue?vue&type=script&lang=js"
export * from "./BookmarksModal.vue?vue&type=script&lang=js"

import "./BookmarksModal.vue?vue&type=style&index=0&id=19cff8ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cff8ba"]])

export default __exports__